// extracted by mini-css-extract-plugin
module.exports = {"root":"AssetsInput_root__bYSMB","active":"AssetsInput_active__wZN_f","error":"AssetsInput_error__3fCew","asset":"AssetsInput_asset__jgIZn"};